export const PagesAvailable = [
    "settings",
    "/utenti",
    "/edifici",
    "/richiesteAccesso",
    "/disponibilita",
    "/planner",
    "/prenotazioni",
    "/trovaCollega",
    "/faq",
    "confermaregistrazione",
    "/"
]